var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VippsCheckoutForm',{attrs:{"amount":_vm.amount,"description":_vm.description,"customer-info":_vm.customerInfo,"currency":_vm.currency}})
}
var staticRenderFns = []

export { render, staticRenderFns }